import { render } from "./AmazonOrderView.vue?vue&type=template&id=2c2c6dbb&scoped=true"
import script from "./AmazonOrderView.vue?vue&type=script&lang=js"
export * from "./AmazonOrderView.vue?vue&type=script&lang=js"

import "./AmazonOrderView.vue?vue&type=style&index=0&id=2c2c6dbb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c2c6dbb"]])

export default __exports__